import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DeviceIdService } from '@services/device-id.service';
import { DeviceInfoService } from '@services/device-info.service';

/**
 * Cabeceras que viajan en toda request, GraphQL y REST: identifican al cliente en cada línea de log.
 * El resto del dispositivo solo va en las operaciones de autenticación, desde el link de Apollo
 * (`graphql.providers.ts`), el único lugar de web que conoce el nombre de la operación.
 */
export const deviceIdInterceptor: HttpInterceptorFn = (req, next) => {
  const deviceId = inject(DeviceIdService).getOrCreate();
  const deviceInfo = inject(DeviceInfoService);

  if (!deviceId) return next(req);

  return next(
    req.clone({
      setHeaders: {
        'X-Device-Id': deviceId,
        'X-Platform': deviceInfo.platform,
        'X-App-Version': deviceInfo.appVersion,
        'X-App-Build': deviceInfo.appBuild,
      },
    }),
  );
};
